module.exports = __webpack_public_path__ + "img/Flag_of_Eritrea.865628db.svg";